// vittyyo app icon used in place of the old "Vittyyo" wordmark in page titles; inherits font-size.
export const BrandName = () => (
  <img src="/vittyyo-icon.svg?v=3" alt="vittyyo" data-testid="brand-app-icon" className="inline-block h-[1.25em] w-auto align-middle -mt-[0.12em] mr-1" draggable={false} />
);

export default BrandName;
